module.exports = __webpack_public_path__ + "img/ExclusiveWema.c5e33c6b.jpeg";